import {
  BooleanField,
  Datagrid,
  DateField,
  List,
  ReferenceField,
  TextField,
  useNotify,
  useRefresh,
  useRecordContext,
} from "react-admin";
import { Chip, Select, MenuItem } from "@mui/material";

import dataProvider from "../../provider/provider";

const Status = () => {
  const record = useRecordContext();

  const notify = useNotify();
  const refresh = useRefresh();
  //const keyPair = ['Banned', 'New', 'LoggedIn']
  return (
    // <Chip label={keyPair[record.status + 1]}></Chip>
    <Select
      size="small"
      value={record?.sentToUser}
      onChange={(e) => {
        dataProvider
          .update("coupon", {
            id: record.id,
            data: {
              id: record.id,
              sentToUser: e.target.value,
            },
          })
          .then((v) => {
            notify("Successfully updated", { type: "success" });
            refresh();
          });
      }}
    >
      <MenuItem value={false}>
        <Chip label="Pending" color="warning" size="small" />
      </MenuItem>
      <MenuItem value={true}>
        <Chip label="Sent" color="success" size="small" />
      </MenuItem>
    </Select>
  );
};

export const CouponList = (props) => {
  return (
    <List {...props} exporter={false}>
      <Datagrid rowClick="show">
        <ReferenceField reference="parent" source="parentId" label="Email">
          <TextField source="email" label="Email" />
        </ReferenceField>
        <ReferenceField reference="parent" source="parentId" label="Phone">
          <TextField source="mobile" label="Phone" />
        </ReferenceField>
        <Status source="sentToUser" label="Send Status" />
        <TextField source="brand" />
        <DateField
          source="createdDate"
          options={{ year: "numeric", month: "long", day: "numeric" }}
        ></DateField>
      </Datagrid>
    </List>
  );
};
